module.exports = __webpack_public_path__ + "img/cbn1r1.b2b46ccc.gif";